function e(){return{c:new Set,e:new Set}}export{e as EmptyRedrawResult};
